import IMAGE_MIME_TYPES from '@@constants/ImageMimeTypes';

export const ELEMENT_TYPES = {
    BLUESKY: 'embed.bluesky',
    CROSSHEAD_DEFAULT: 'crosshead.default',
    CROSSHEAD_SUBSECTION: 'crosshead.subsection',
    CROSSHEAD_LISTICLE_ORDERED: 'crosshead.listicle-ordered',
    CROSSHEAD_LISTICLE_UNORDERED: 'crosshead.listicle-unordered',
    CUSTOM_JSON: 'customJson',
    DYNAMIC_TEASER: 'layout.dynamic-teaser',
    DYNAMIC_TEASER_TITLE: 'layout.dynamic-teaser-title',
    EMBEDDED_CONTENT: 'embed.embeddedcontent',
    EMBEDDED_SNIPPET: 'embed.snippet',
    SNIPPET: 'snippet',
    FACEBOOK: 'embed.facebook',
    FOOTER: 'footer',
    FRONTEND_COMPONENT: 'embed.frontendComponent',
    IMAGE: 'embed.image',
    INFOBOX: 'layout.infobox',
    INFOBOX_TITLE: 'layout.infobox-title',
    INFOBOX_CONTENT: 'layout.infobox-content',
    INSTAGRAM: 'embed.instagram',
    INTERVIEW_SEGMENT: 'layout.interview-segment',
    INTERVIEW_SEGMENT_QUESTION: 'layout.interview-segment-question',
    INTERVIEW_SEGMENT_ANSWER: 'layout.interview-segment-answer',
    LEAD: 'lead',
    EXTERNAL_LINK: 'link',
    INTERNAL_LINK: 'internalLink',
    CATEGORY_LINK: 'categoryLink',
    TAG_LINK: 'tagLink',
    AUTHOR_LINK: 'authorLink',
    ORDERED_LIST: 'ordered-list',
    UNORDERED_LIST: 'unordered-list',
    LIST_ITEM: 'list-item',
    LIST_ITEM_CONTENT: 'lic',
    PARAGRAPH: 'paragraph',
    POLL: 'poll',
    POLL_QUESTION: 'poll-question',
    POLL_ANSWER: 'poll-answer',
    RATING_POLL: 'rating-poll',
    QUOTE: 'layout.quote',
    QUOTE_TEXT: 'layout.quote-text',
    QUOTE_CAPTION: 'layout.quote-caption',
    SEPARATOR: 'layout.separator',
    SLIDESHOW: 'embed.slideshow',
    CS_SLIDESHOW: 'slideshow',
    SUMMARY_LIST: 'summary-list',
    SUMMARY_LIST_SUMMARY: 'summary-list.summary',
    TEXT_ITEM: 'text-item',
    THREADS: 'embed.threads',
    TIKTOK: 'embed.tiktok',
    TITLE: 'title',
    TITLE_HEADER: 'title-header',
    CAPTION_TITLE: 'caption-title',
    CAPTION: 'caption',
    CREDIT: 'credit',
    TWITTER: 'embed.twitter',
    // TODO: Once slate.js is gone, camelCase this value
    VIDEO_CMS: 'embed.videocms',
    // TODO: Once slate.js is gone, camelCase this value
    VIDEO_CMS_LIVESTREAM: 'embed.videocmsLivestream',
    YOUTUBE: 'embed.youtube',
    YOUTUBE_CREDIT: 'embed.youtube.credit',
    ZATTOO: 'embed.zattoo',
} as const;

export const UNITY_ELEMENT_TYPES = {
    TEXT: 'text',
    POLLITEM: 'poll-item',
    CROSSHEAD: 'crosshead',
    // This doesn't match our other patterns, but is how it is in the Backend
    VIDEO_CMS: 'embed.videocms',
    VIDEO_CMS_LIVESTREAM: 'embed.videocmsLivestream',
} as const;

export type ElementType = ValueOf<typeof ELEMENT_TYPES> | ValueOf<typeof UNITY_ELEMENT_TYPES>;

export const FACEBOOK_MIME_TYPES = {
    FACEBOOK_POST: 'x-facebook/post',

    /**
     * @deprecated use FACEBOOK_POST instead
     */
    FACEBOOK_COMMENT: 'x-facebook/comment',

    /**
     * @deprecated use FACEBOOK_POST instead
     */
    FACEBOOK_PAGE: 'x-facebook/page',

    /**
     * @deprecated use FACEBOOK_POST instead
     */
    FACEBOOK_VIDEO: 'x-facebook/video',
} as const;

export const MIME_TYPES = {
    BLUESKY: 'x-bluesky/post',
    EMBEDDED_CONTENT: 'x-iframe/*',
    EMBEDDED_SNIPPET: 'x-unity/snippet',
    FRONTEND_COMPONENT: 'x-unity/frontend-component',
    SLIDESHOW: 'x-unity/slideshow',
    TIKTOK: 'x-tiktok/post',
    THREADS: 'x-unity/threads',
    VIDEO_CMS: 'x-videocms/video',
    VIDEO_CMS_LIVESTREAM: 'x-videocms/livestream',
    YOUTUBE: 'x-youtube/video',
    ZATTOO: 'x-zattoo/video',
    INSTAGRAM: 'x-instagram/post',
    TWITTER: 'x-twitter/tweet',
    ...FACEBOOK_MIME_TYPES,
    ...IMAGE_MIME_TYPES,
} as const;

export const MARKS = {
    BOLD: 'bold',
    ITALIC: 'italic',
    UNDERLINE: 'underline',
    // CODE: 'code',
    SUBSCRIPT: 'subscript',
    SUPERSCRIPT: 'superscript',
    // COMMENT: 'commentId',
} as const;

export const NameSource = {
    AI: 'ai',
    ASSETS: 'assets',
    UNITY: 'unity',
} as const;

export type NameSource = ValueOf<typeof NameSource>;

export const CROSSHEAD_STYLES = {
    SECTION: '_crosshead_default',
    SUBSECTION: '_crosshead_subsection',
    ORDERED_LISTICLE: '_crosshead_listicle',
    UNORDERED_LISTICLE: '_crosshead_listicle_unordered',
} as const;
